export default "__VITE_ASSET__rL5IHY8O__"